import { SearchOutlined } from '@mui/icons-material';
import { Divider, Stack } from '@mui/material';
import { TextField } from '@procureai/ui-form-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '@/legacy/common/types';

import { useCockpitPanel } from './CockpitPanel.hook';
import { FilterChip } from './components/FilterChip/FilterChip';
import { ThreadList } from './components/ThreadList/ThreadList';

export const CockpitPanel = () => {
  const { t } = useTranslation(I18nNamespace.cockpit, { keyPrefix: 'AgentPanel' });

  const { debouncedTextFilter, textFilter, setTextFilter, options, activeFilters, toggleFilter } = useCockpitPanel();

  return (
    <>
      <Stack flex={1} minHeight={0} direction="column">
        <TextField
          sx={{ p: 2 }}
          placeholder={t('actions.search')}
          variant="outlined"
          size="small"
          startAdornment={<SearchOutlined />}
          value={textFilter}
          onChange={setTextFilter}
        />
        <Stack direction="row" padding={2} spacing={1} sx={{ overflowX: 'auto', justifyContent: 'space-evenly' }}>
          {options.map((filter) => (
            <FilterChip
              key={filter}
              agent={filter}
              active={activeFilters.includes(filter)}
              onClick={() => toggleFilter(filter)}
            />
          ))}
        </Stack>
        <Divider />
        <Stack
          flex={1}
          minHeight={0}
          sx={{
            overflowY: 'auto',
          }}
        >
          <ThreadList categories={activeFilters} textFilter={debouncedTextFilter} />
        </Stack>
      </Stack>
    </>
  );
};
